import { List } from 'immutable';
import State from './core/State';

const initialState: State = {
  authentication: {
    signedInUser: null,
    fetching: 0,
  },
  fatalError: null,
  fullScreenSpinner: {
    necessity: 0,
    loadingMessage: '',
  },
  language: 'ja-JP',
  location: {
    pathname: '/',
    search: '',
  },
  nonFatalErrors: List(),
  region: 'jp',
  snackbar: {
    message: null,
    messageValues: {},
    action: null,
    actionValues: {},
    isRaw: false,
    onClickAction: null,
  },
  user: {
    data: null,
    fetching: 0,
    isPublic: true,
  },
  work: {
    item: null,
    fetching: 0,
  },
  works: {
    items: [],
    fetching: 0,
    nextCursor: null,
  },
  translations: {},
};

export default initialState;
